"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REG_FORM_VALUE_WHITELIST = void 0;
// These fields will have their values tracked on change.
// Take care not to transmit any PII
exports.REG_FORM_VALUE_WHITELIST = ['patient.phone.type'];
//# sourceMappingURL=constants.js.map